import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  useEffect(() => {
    const followMouse = (e) => {
      const cursor = document.querySelector('.cursor-customizado');
      
      if (cursor) {
        cursor.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0)`;
      }
    };

    window.addEventListener('mousemove', followMouse);

    return () => {
      window.removeEventListener('mousemove', followMouse);
    };
  }, []); 

  return (
    <footer className="footer" style={{ padding: '20px 0', borderTop: '1px solid #eee', marginTop: '40px' }}>
      <div className="container text-center">
        <p className="m-0">© 2026 copyright all right reserved</p>
        
        <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center', gap: '15px' }}>
          <Link to="/privacy" style={{ textDecoration: 'none', color: '#666', fontSize: '14px' }}>
            Política de Privacidade
          </Link>
          <Link to="/terms" style={{ textDecoration: 'none', color: '#666', fontSize: '14px' }}>
            Termos de Serviço
          </Link>
        </div>
      </div>
    </footer>
  );
}